import { getAppConfigSetting } from '../utils'

export const ACATS_TRANSFER_DETAILS_API = (acatsControlNumber: string) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v2/acats/${acatsControlNumber}/details`

export const ACATS_SEARCH_API = `${getAppConfigSetting(
  'alpsApiUrl'
)}/alps/api/v2/acats/search`

export const ACATS_MARGIN_DETAILS_API = (
  accountNumber: string,
  acatsControlNumber: string
) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v2/margin/${accountNumber}/${acatsControlNumber}`

export const ACATS_DOCUMENTS_API = (
  accountNumber: string,
  documentTypes: string
) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v1/documents/${accountNumber}/${documentTypes}`

export const ACATS_CASE_STATUS_API = (acatId: string) =>
  `${getAppConfigSetting('alpsApiUrl')}/alps/api/v2/acats/${acatId}/status`

export const ACATS_CASE_ACCEPT_API = (processingCaseId: number) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v2/resolutions/${processingCaseId}/accept`

export const ACATS_CASE_REJECT_API = (processingCaseId: number) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v2/resolutions/${processingCaseId}/reject`

export const WITH_CREDENTIALS_CONFIG = {
  withCredentials: true,
}

export const getCaseAssetsUrl = (caseId: number) =>
  `${getAppConfigSetting('alpsApiUrl')}/alps/api/v1/analysis/${caseId}/assets`

export const getAssetMetadataUrl = (caseId: number, assetId: number) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v1/analysis/${caseId}/assets/${assetId}`

export const getStatefulPropertiesUrl = (
  caseId: number,
  assetId: number,
  assetInputId: number
) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v1/analysis/${caseId}/assets/${assetId}/${assetInputId}`

export const ACATS_AUDIT_TRAIL_API = (processingCaseId: number) =>
  `${getAppConfigSetting(
    'alpsApiUrl'
  )}/alps/api/v1/processing/${processingCaseId}/audits`

export const ACCOUNTS_API = `${getAppConfigSetting(
  'apiUrl'
)}/atlas/api/v1/accounts`

export const CORRESPONDENTS_API = `${getAppConfigSetting(
  'apiUrl'
)}/correspondent-provider/api/v2/correspondents`

export const TIF_API = `${getAppConfigSetting('alpsApiUrl')}/alps/api/v1/tif`
